<h2 mat-dialog-title class="gl-preview-header">
	<span class="gl-preview-title">{{ data.title }}</span>
	<span class="gl-preview-badges" *ngIf="hasLines">
		<span class="badge badge-debit">Debits {{ debitTotal | currency }}</span>
		<span class="badge badge-credit">Credits {{ creditTotal | currency }}</span>
	</span>
</h2>

<mat-dialog-content class="gl-preview-content">
	<app-transaction-gl-table
		[lines]="data.lines"
		[exportTitle]="data.title"
		[showScreenHeading]="false"
		[documentTypeId]="data.documentTypeId"
		[documentTransno]="data.documentTransno"
		(lineSaved)="onLineSaved()"
	></app-transaction-gl-table>
</mat-dialog-content>

<mat-dialog-actions align="end" class="gl-preview-actions gl-preview-actions-row">
	<button mat-raised-button color="primary" type="button" (click)="close()">Close</button>
</mat-dialog-actions>
